import { Dialog, DialogContent } from '@/components/atoms/Dialog';
import { Button } from '@/components/atoms/PcButton';

import { cn } from '@/utils/tailwind';

interface CoupangWingDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  onConfirm: (wingId: string) => void;
  error?: boolean;
  setError?: (v: boolean) => void;
  input: string;
  setInput: (v: string) => void;
}

const CoupangWingDialog = ({
  open,
  setOpen,
  onConfirm,
  error = false,
  setError,
  input,
  setInput,
}: CoupangWingDialogProps) => {
  const handleConfirm = () => {
    if (!input.trim()) return;
    onConfirm(input.trim());
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent noCloseBtn className="max-w-[380px] rounded-[20px] p-[30px]">
        <div className="flex flex-col items-stretch gap-[20px]">
          <div className="flex flex-col gap-[4px]">
            <div className="text-gr-900 Title3S18">쿠팡 ID를 입력해 주세요</div>
            <div className="text-gr-700 Body5M14">
              문의 답변 기능 사용을 위해 ID 등록이 필요해요.
              <br />이 작업은 쿠팡 계정 별 최초 1번만 진행돼요
            </div>
          </div>
          <div className="flex flex-col gap-[8px]">
            <input
              className={cn(
                '  rounded-[8px] border px-[10px] py-[13px] outline-none transition Body5M14 focus:border-point-500',
                error && 'border-red-400 ',
              )}
              placeholder="아이디를 입력하세요"
              value={input}
              onChange={(e) => {
                setInput(e.target.value);
                setError?.(false);
              }}
              autoFocus
            />
            {error && <div className="text-red-500 Body5M14">아이디가 일치하지 않습니다.</div>}
          </div>
          <div className="flex gap-2">
            <Button
              variant="muted"
              className="h-[44px] flex-1 rounded-[8px] Body5M14"
              onClick={() => {
                setOpen(false);
                setInput('');
                setError?.(false);
              }}
              type="button"
            >
              닫기
            </Button>
            <Button
              className="h-[44px] flex-1 rounded-[8px] Body5M14"
              onClick={handleConfirm}
              disabled={!input.trim()}
              type="button"
            >
              확인
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
export default CoupangWingDialog;
